import Vue from 'vue'
import Router from 'vue-router'
import Filters from './components/Filters.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'filters',
      component: Filters,
      props(route) {
        return  route.query || {}
      }
    }
  ],
})
